/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserNotificationParameterResponse } from './RevisdomAPIViewModelsUserNotificationParameterResponse';
import {
    RevisdomAPIViewModelsUserNotificationParameterResponseFromJSON,
    RevisdomAPIViewModelsUserNotificationParameterResponseFromJSONTyped,
    RevisdomAPIViewModelsUserNotificationParameterResponseToJSON,
    RevisdomAPIViewModelsUserNotificationParameterResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserNotificationParameterResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserNotificationResponse
 */
export interface RevisdomAPIViewModelsUserNotificationResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    notificationText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    notificationFullText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    notificationTarget?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserNotificationParameterResponse>}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    parameters?: Array<RevisdomAPIViewModelsUserNotificationParameterResponse> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    isRead?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserNotificationResponse
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserNotificationResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserNotificationResponse(value: object): value is RevisdomAPIViewModelsUserNotificationResponse {
    return true;
}

export function RevisdomAPIViewModelsUserNotificationResponseFromJSON(json: any): RevisdomAPIViewModelsUserNotificationResponse {
    return RevisdomAPIViewModelsUserNotificationResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'notificationText': json['notificationText'] == null ? undefined : json['notificationText'],
        'notificationFullText': json['notificationFullText'] == null ? undefined : json['notificationFullText'],
        'notificationTarget': json['notificationTarget'] == null ? undefined : json['notificationTarget'],
        'parameters': json['parameters'] == null ? undefined : ((json['parameters'] as Array<any>).map(RevisdomAPIViewModelsUserNotificationParameterResponseFromJSON)),
        'isRead': json['isRead'] == null ? undefined : json['isRead'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function RevisdomAPIViewModelsUserNotificationResponseToJSON(json: any): RevisdomAPIViewModelsUserNotificationResponse {
    return RevisdomAPIViewModelsUserNotificationResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserNotificationResponseToJSONTyped(value?: RevisdomAPIViewModelsUserNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'notificationText': value['notificationText'],
        'notificationFullText': value['notificationFullText'],
        'notificationTarget': value['notificationTarget'],
        'parameters': value['parameters'] == null ? undefined : ((value['parameters'] as Array<any>).map(RevisdomAPIViewModelsUserNotificationParameterResponseToJSON)),
        'isRead': value['isRead'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

